/* eslint-disable */
import md5 from 'blueimp-md5'

export const STORE_KEY = '__DEX_DEVICE_ID__'

export const DEFAULT_PLACEHOLDER = 'unknown'

const memoryStorage = {}

const isSupportSession = () => typeof window.sessionStorage !== 'undefined'
const isSupportLocal = () => typeof window.localStorage !== 'undefined'

const setDevice = value => {
  const name = STORE_KEY
  const storeVal = JSON.stringify(value)

  // cookie
  document.cookie = `${name}=${storeVal};expires=Fri, 31 Dec 9999 23:59:59 GMT;Path=/;secure=true;`

  // localStorage
  if (isSupportLocal()) {
    localStorage.setItem(name, storeVal)
  }

  // sessionStorage
  if (isSupportSession()) {
    sessionStorage.setItem(name, storeVal)
  }

  // memoryStorage
  memoryStorage[STORE_KEY] = storeVal
}

export const getDevices = () => {
  const name = STORE_KEY
  let deviceStr = null

  // from memoryStorage
  if (!deviceStr) {
    deviceStr = memoryStorage[STORE_KEY]
  }

  // from cookie
  if (document.cookie) {
    const reg = new RegExp(`(?:(?:^|.*;\\s*)${name}\\s*=\\s*([^;]*).*$)|^.*$`)
    deviceStr = document.cookie.replace(reg, '$1')
  }

  // from localStorage
  if (!deviceStr && isSupportLocal()) {
    deviceStr = localStorage.getItem(name) || null
  }

  // from sessionStorage
  if (!deviceStr && isSupportSession()) {
    deviceStr = sessionStorage.getItem(name) || null
  }

  const device = JSON.parse(deviceStr) || {}

  // recover
  deviceStr && setTimeout(() => setDevice(device), 0)
  return device
}

export const getCurrentDeviceId = address => {
  if (!address) return ''

  try {
    const devices = getDevices()
    const addressEncode = md5(address)
    const device = devices[addressEncode]

    if (device && device.value) {
      return device.value
    }

    return ''
  } catch (e) {
    console.warn('getCurrentDeviceId error: ', e)
    return ''
  }
}

export const saveCurrentDeviceId = (address, val) => {
  try {
    const devices = getDevices()
    const addressEncode = md5(address)
    const device = devices[addressEncode]

    if (!device) {
      // delete first date.
      let tmpList = []
      for (const k in devices) {
        tmpList.push({
          k,
          v: devices[k],
        })
      }

      if (tmpList.length === 10) {
        tmpList = tmpList.sort((prev, next) => prev.v.date - next.v.date)
        const first = tmpList[0] || {}
        delete devices[first.k]
      }
    }

    devices[addressEncode] = {
      date: new Date().getTime(),
      value: val,
    }

    setDevice(devices)
  } catch (e) {
    console.warn('saveCurrentDeviceId error: ', e)
    return ''
  }
}
